.TableErrorState {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 40px;
  text-align: center;
  white-space: pre-line;

  .ErrorMessage {
    width: 560px;
    text-align: left;
  }

  &.TopMargin {
    margin-top: 110px;
  }

  .RefreshButton {
    svg {
      padding-right: 0.5em;
    }
  }
}
